module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "border-bottom-medium pb-5 px-5"
  }, [_c('div', {
    staticClass: "text-center fs-largest bold"
  }, [_vm._v("How to connect with GetYourGuide")]), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-4 mb-3"
  }, [_c('img', {
    staticStyle: {
      "max-width": "75px",
      "max-height": "75px"
    },
    attrs: {
      "src": _vm.gygOta.logo,
      "alt": "Logo GetYourGuide"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "px-5 pt-5 pb-4"
  }, [_c('div', {}, [_c('div', {
    staticClass: "d-flex stepRow"
  }, [_c('div', {
    staticClass: "stepNumber d-flex border-dark align-items-center justify-content-center"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "stepText d-flex flex-grow-1"
  }, [_vm._v("\n                    Set your commissions and payment protocol with GetYourGuide.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "stepButton d-flex"
  }, [(_vm.creatingProtocol) ? _c('loader') : (!_vm.isIntegrated) ? _c('button', {
    staticClass: "btn tertiary w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.crateProtocol()
      }
    }
  }, [_vm._v("Create Protocol")]) : (_vm.isIntegrated) ? _c('button', {
    staticClass: "btn tertiary w-100",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-check color-3"
  }), _vm._v(" Created")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex stepRow"
  }, [_c('div', {
    staticClass: "stepNumber d-flex border-dark align-items-center justify-content-center"
  }, [_vm._v("2")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "stepButton d-flex"
  }, [_c('button', {
    staticClass: "btn tertiary w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickInstructionsGuide
    }
  }, [_vm._v("Instructions Guide")])])])]), _vm._v(" "), _c('div', {
    staticClass: "productListHolder"
  }, [_c('list', {
    staticClass: "mt-4",
    attrs: {
      "header": _vm.productListHeader,
      "body": _vm.productListBody,
      "rows": _vm.products
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-4"
  }, [_c('button', {
    staticClass: "btn wide tertiary flex-grow-1 mr-2",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn wide primary flex-grow-1 ml-2",
    attrs: {
      "type": "button",
      "name": "button",
      "disabled": !_vm.isIntegrated
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Done, I’m connected")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "darkest"
  }, [_vm._v("\n            Pluralo offers a integration with GetYourGuide."), _c('br'), _vm._v("\n            This means that when a customer is booking your experiences at GetYourGuide, it will be displaying availability from your Pluralo account and you will see bookings directly at your reservations page.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-blue-pale p-2 mt-3"
  }, [_vm._v("\n            Please note that you need to have active products on GYG in order to connect with Pluralo. Log into your "), _c('a', {
    staticClass: "darkest underlined",
    attrs: {
      "href": "https://supplier.getyourguide.com/",
      "target": "_blank"
    }
  }, [_vm._v("Supply Portal")]), _vm._v(".  Don’t have an account? "), _c('a', {
    staticClass: "darkest underlined",
    attrs: {
      "href": "https://supplier.getyourguide.com/en/register",
      "target": "_blank"
    }
  }, [_vm._v("Sign Up here")]), _vm._v(".\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stepText d-flex flex-grow-1"
  }, [_c('div', [_vm._v("\n                        Log into your "), _c('a', {
    staticClass: "color-1 underlined bold",
    attrs: {
      "href": "https://supplier.getyourguide.com/",
      "target": "_blank"
    }
  }, [_vm._v("Supply Portal")]), _vm._v(" and using the table bellow connect the products ID."), _c('br'), _c('b', [_vm._v("Follow the GYG instructions guide to finish the connection on their site")]), _vm._v(".\n                    ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7ac96002", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ac96002"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/otas/getYourGuide/howToConnect/howToConnect.vue
// module id = 2016
// module chunks = 0